import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../../components/NPS/components/Card.js';
import { Container } from '../../components/NPS/components/Container.js';
import { Headline } from '../../components/NPS/components/Headline.js';
import { Rating } from '../../components/NPS/components/Rating/index.js';
import { RatingDefinition } from '../../components/NPS/components/RatingDefinition/index.js';
import { SubmitButton } from '../../components/NPS/components/SubmitButton.js';
import { ThanksForFeedback } from '../../components/NPS/components/ThanksForFeedback/index.js';
import { Divider, LabelMediumSemiBold, Stack, TextArea } from '../../primitives/index.js';
import { qaId } from '../../utils/index.js';
import { NPS_FEEDBACK_QA_ID } from '../../utils/qaId.js';
export const NPS = React.memo(({
  sendData,
  children
}) => {
  const {
    t
  } = useTranslation('NPS');
  const [send, setSend] = useState(false);
  const [ratingScore, setRatingScore] = useState(-1);
  const [ratingText, setRatingText] = useState('');
  const [disableButton, setDisableButton] = useState(true);
  const handleClick = () => {
    sendData(ratingScore, ratingText);
    setSend(true);
    setDisableButton(true);
  };
  const handleTextChange = e => {
    setRatingText(e.currentTarget.value);
  };
  const handleScoreChange = e => {
    setRatingScore(+e.currentTarget.value);
  };
  useEffect(() => {
    if (ratingScore >= 0 && !send) setDisableButton(false);
  }, [ratingScore, send]);
  return _jsxs(Container, {
    "data-testid": qaId(NPS_FEEDBACK_QA_ID),
    children: [children && _jsxs(_Fragment, {
      children: [children, _jsx(Divider, {})]
    }), send ? _jsx(ThanksForFeedback, {}) : _jsxs(Card, {
      children: [_jsx(Headline, {
        medium: !!children,
        children: t(`title`, {
          context: !children && 'standalone'
        })
      }), _jsxs(Stack, {
        spacing: 2,
        children: [_jsxs(Stack, {
          spacing: 0.75,
          children: [_jsx(LabelMediumSemiBold, {
            children: t('question')
          }), _jsx(RatingDefinition, {
            min: 0,
            minLabel: t('minLabel'),
            max: 10,
            maxLabel: t('maxLabel')
          }), _jsx(Rating, {
            min: 0,
            max: 10,
            onChange: handleScoreChange,
            selected: ratingScore
          })]
        }), _jsxs(Stack, {
          spacing: 0.75,
          children: [_jsx(LabelMediumSemiBold, {
            children: t('improvementQuestion')
          }), _jsx(TextArea, {
            "aria-labelledby": t('textArea'),
            "data-testid": (qaId(NPS_FEEDBACK_QA_ID), 'text'),
            value: ratingText,
            onChange: handleTextChange,
            placeholder: t('textArea')
          })]
        })]
      }), _jsx(SubmitButton, {
        "data-testid": (qaId(NPS_FEEDBACK_QA_ID), `submitButton${disableButton ? 'Inactive' : 'Active'}`),
        onClick: handleClick,
        disabled: disableButton,
        children: t('button')
      })]
    })]
  });
});